import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IListFilterItem, ListFilterItem } from "../../../models/common/listFilterItem";
import { ISavedListFilter } from "../../../models/common/savedListFilter";
import { ITypedOption } from "../../../models/common/typedOption";
import { IReportItem } from "../../../models/report/reportItem";
import * as documentService from "../../../models/services/documentService";
import { recordLockManager } from "../../../models/services/recordLockService";
import * as userService from "../../../models/services/userService";
import { IAppSessionState } from "../../../models/store/storeTypes";
import { HeaderMenuItem, NavigationMenu } from "../../app/NavigationMenu";
import { ListFilterSaveDialog } from "../../framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "../../framework/Page/PageContainer";
import { PageContent } from "../../framework/Page/PageContent";
import { IPageNavMenuItem } from "../../framework/PageNav/PageNavMenuItems";
// import { PageListAndReportsContainer } from "../../framework/Page/PageListAndReportsContainer";
import { PageTopBar } from "../../framework/Page/PageTopBar";
// import { FilterTabs } from "../../framework/PageNavMenuItem/FilterTabs";
import { AppUtils } from "source/framework/appUtils";
import { userParameterCodeShowDocumentPreview } from "source/models/common/webConsts";
import { IDocumentPage } from "source/models/document/documentPage";
import { UserMenu } from "../../app/UserMenu";
import { DocumentFilterDrawer } from "../DocumentFilterDrawer";
import { DocumentFolders } from "../DocumentFolders";
import { DocumentPageDashboardChart, IDocumentPageFilterState } from "../DocumentPageDashboardChart";
import { DocumentSettingsDialog, DocumentSettingsDialogMenuItem } from "../DocumentSettingsDialog";
import { abortManager } from "source/models/services/tokenService";

// DocumentPage
export interface IDocumentPageOwnProps {
}

export interface IDocumentPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    documentPage: IDocumentPage;
}

export interface IDocumentPageDispatchProps {
    onGetDocumentPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

type DocumentPageProp = IDocumentPageOwnProps & IDocumentPageStateProps & IDocumentPageDispatchProps;

interface IDocumentPageState extends IDocumentPageFilterState {
    initialized: boolean;
    listDataPreloaded: boolean;
    keywords: IIdTitle[];
    dynamicTimeFilters: IIdTitle[];
    documentEndDateDynamicTimeFilters: IIdTitle[];
    activeCompanyId: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    settingsActions: IPageNavMenuItem[];
    canEditProperties: boolean;
    // Filters
    listFilterIsSet: boolean;
    showListFilter: boolean;
    listFilterFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Permissions
    dataId: number;
    // Settings
    showSettingsDialog: boolean;
    // Preview
    editMode: boolean;
    showDocumentPreview: boolean;
    showPublishedVersionOnDocumentPreview: boolean;
}

export class DocumentPage extends React.Component<DocumentPageProp, IDocumentPageState> {
    getDynamicTimeFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("0", "'" + Translations.SpecifedTimeFrame + "'"));
        result.push(IdTitle.createIdTitle("1", Translations.Last7Days));
        result.push(IdTitle.createIdTitle("2", Translations.Last30Days));
        result.push(IdTitle.createIdTitle("3", Translations.LastYear));
        result.push(IdTitle.createIdTitle("4", Translations.PreviousCalendarWeek));
        result.push(IdTitle.createIdTitle("5", Translations.PreviousCalendarMonth));
        result.push(IdTitle.createIdTitle("6", Translations.PreviousCalendarYear));
        return result;
    };

    getDocumentEndDateDynamicTimeFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("0", "'" + Translations.SpecifedTimeFrame + "'"));
        result.push(IdTitle.createIdTitle("1", Translations.Expired));
        result.push(IdTitle.createIdTitle("2", String.format(Translations.ExpiresInParameterDays, 7)));
        result.push(IdTitle.createIdTitle("3", String.format(Translations.ExpiresInParameterDays, 30)));
        result.push(IdTitle.createIdTitle("4", String.format(Translations.ExpiresInParameterDays, 60)));
        result.push(IdTitle.createIdTitle("5", String.format(Translations.ExpiresInParameterMonths, 3)));
        result.push(IdTitle.createIdTitle("6", String.format(Translations.ExpiresInParameterMonths, 6)));
        result.push(IdTitle.createIdTitle("7", Translations.ExpiresInYear));
        return result;
    };

    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        return result;
    };
    
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.Documents, Translations.Documents,
            DocumentPageDashboardChart.getGeneralFilterFromState(null), "name", true, 0));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getListFilterIsSet = (state: IDocumentPageState): boolean => {
        return DocumentFilterDrawer.filterIsSet(state, state);
    };

    getSettingsActions = (canEditProperties: boolean): IPageNavMenuItem[] => {
        const result: IPageNavMenuItem[] = [];
        const props = this.props;
        const sessionState = props.appState.state;
        if (canEditProperties) {
            result.push({ id: DocumentSettingsDialogMenuItem.Keywords, title: Translations.Keywords });
            result.push({ id: DocumentSettingsDialogMenuItem.DocumentTemplates, title: Translations.DocumentTemplates });
        }
        if (sessionState.isSuperAdmin) {
            result.push({ id: DocumentSettingsDialogMenuItem.SharedDocumentTemplates, title: Translations.SharedDocumentTemplates });
        }
        if (canEditProperties) {
            result.push({ id: DocumentSettingsDialogMenuItem.FileFilters, title: Translations.FileFilters });
        }
        if (canEditProperties) {
            result.push({ id: DocumentSettingsDialogMenuItem.OtherSettings, title: sessionState.isSuperAdmin ? Translations.OtherSettings : Translations.VersionHistory });
        }
        return result;
    };

    constructor(props: DocumentPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filterProps = ListFilterItem.getFilterProps(filters[0], "name", true, DocumentPageDashboardChart.getStateFilterPropsFromGeneralFilter);
        const dynamicTimeFilters = this.getDynamicTimeFilters();
        const documentEndDateDynamicTimeFilters = this.getDocumentEndDateDynamicTimeFilters();
        const canEditProperties = props.documentPage?.canEditProperties;
        const state = {
            ...filterProps,
            initialized: false,
            activeCompanyId: sessionState.companyId,
            listDataPreloaded: true,
            keywords: props.documentPage?.keywords ?? [],
            dynamicTimeFilters,
            documentEndDateDynamicTimeFilters,
            selectedStartDate: 0,
            selectedEndDate: 0,
            selectedDynamicTimeFilterId: dynamicTimeFilters[0].id,
            selectedDocumentEndDateStartDate: 0,
            selectedDocumentEndDateEndDate: 0,
            selectedDynamicDocumentEndDateFilterId: documentEndDateDynamicTimeFilters[0].id,
            canEditProperties,
            settingsActions: this.getSettingsActions(canEditProperties),
            // Folders
            folderNode: null,
            // Filters
            listFilterIsSet: false,
            activeFilterId: filters[0].id,
            activeSavedFilterId: "",
            filters,
            savedFilters: ListFilterItem.getListFilterItems(props.documentPage?.companyFilters, props.documentPage?.userFilters),
            showListFilter: false,
            listFilterFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Permissions
            dataId: props.dataId,
            // Settings
            showSettingsDialog: false,
            // Preview
            editMode: false,
            showDocumentPreview: false,
            showPublishedVersionOnDocumentPreview: true
        };
        this.state = {
            ...state,
            //dashBoardPanels: SavedChartPanel.getDashBoardPanels(props.messagePage?.panels, props.messagePage?.chartPanels, state.chartItems, ApplicationPermissionType.Message),
            listFilterIsSet: this.getListFilterIsSet(state)
        };
    }

    // getReports = async (companyId: string) => {
    //     const state = this.state;
    //     const newState = await ReportItems.getReportsState(companyId, state.activeReportId, this.getHtlmlReportItems(), eventService.getEventPageReportItems,
    //         () => {
    //             if (!this._isMounted) return;
    //             this.setState({ loadingReports: true });
    //         },
    //         () => {
    //             if (!this._isMounted) return;
    //             this.setState({ loadingReports: false });
    //         });
    //     if (!this._isMounted || !newState) return;
    //     const props = this.props;
    //     this.setState({
    //         ...newState,
    //         dashBoardPanels: SavedChartPanel.getDashBoardPanels(props.messagePage?.panels, props.messagePage?.chartPanels, newState.chartItems, ApplicationPermissionType.Message)
    //     });
    // };

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
        this.props.onGetDocumentPage();
        // this.getReports(sessionState.companyId);
    }

    componentDidUpdate(prevProps: DocumentPageProp, prevState: IDocumentPageState): void {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const equalCompanyIds = Base.equalStrArrays(prevProps.documentPage?.companies.map(i => i.id) ?? [], props.documentPage?.companies.map(i => i.id) ?? []);
        // const prevCompanyId = prevProps.documentPage && prevProps.documentPage.companies.length > 0 ? prevProps.documentPage.companies[0].id : sessionState.companyId;
        // const companyId = props.documentPage && props.documentPage.companies.length > 0 ? props.documentPage.companies[0].id : sessionState.companyId;
        const prevCompanyId = prevProps.documentPage ? prevProps.documentPage.companyId : sessionState.companyId;
        const companyId = props.documentPage ? props.documentPage.companyId : sessionState.companyId;
        const prevCanEditDocuments = prevProps.documentPage?.canEditDocuments ?? false;
        const canEditDocuments = props.documentPage?.canEditDocuments ?? false;
        const prevCanEditProperties = prevProps.documentPage?.canEditProperties ?? false;
        const canEditProperties = props.documentPage?.canEditProperties ?? false;
        const prevCanEditRootFolderProperties = prevProps.documentPage?.canEditRootFolderProperties ?? false;
        const canEditRootFolderProperties = props.documentPage?.canEditRootFolderProperties ?? false;
        const keywords = props.documentPage?.keywords ?? [];
        const equalKeywords = IdTitle.equal(prevProps.documentPage?.keywords ?? [], keywords);
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCanEditDocuments === canEditDocuments &&
            prevCanEditProperties === canEditProperties && prevCanEditRootFolderProperties === canEditRootFolderProperties &&
            equalCompanyIds && equalKeywords) return;
        const savedFilters = ListFilterItem.getListFilterItems(props.documentPage?.companyFilters, props.documentPage?.userFilters);
        const selectedKeywordIds = equalKeywords ? state.selectedKeywordIds : [];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            dataId: props.dataId,
            initialized: !!props.documentPage,
            //dashBoardPanels: SavedChartPanel.getDashBoardPanels(props.documentPage?.panels, props.documentPage?.chartPanels, state.chartItems, ApplicationPermissionType.Document),
            //activeViewTypeId: companyId !== sessionState.companyId ? MessagePageViewTypeId.Records : state.activeViewTypeId,
            activeCompanyId: companyId,
            keywords,
            selectedKeywordIds,
            savedFilters,
            activeSavedFilterId,
            canEditProperties,
            settingsActions: this.getSettingsActions(canEditProperties),
            showDocumentPreview: props.documentPage?.showDocumentPreview ?? state.showDocumentPreview
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    }

    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem) => {
        const state = this.state;
        let result = {
            selectedKeywordIds: state.selectedKeywordIds,
            selectedKeywordOperatorId: state.selectedKeywordOperatorId,
            selectedDocumentApprovalId: state.selectedDocumentApprovalId,
            selectedDocumentContentSearchId: state.selectedDocumentContentSearchId,
            selectedMaxResultsCount: state.selectedMaxResultsCount,
            selectedStartDate: state.selectedStartDate,
            selectedEndDate: state.selectedEndDate,
            selectedDynamicTimeFilterId: state.selectedDynamicTimeFilterId,
            selectedDocumentEndDateStartDate: state.selectedDocumentEndDateStartDate,
            selectedDocumentEndDateEndDate: state.selectedDocumentEndDateEndDate,
            selectedDynamicDocumentEndDateFilterId: state.selectedDynamicDocumentEndDateFilterId,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            result = ListFilterItem.getFilterProps(listItemFilter, result.sortColumn, result.sortOrderIsAsc, DocumentPageDashboardChart.getStateFilterPropsFromGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshPageData(companyId);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return {};
        const filterProps = this.getFilterPropsWithState(filter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return {};
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Document);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showListFilter: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            listFilterFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, DocumentPageDashboardChart.getGeneralFilterFromState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.Document);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: DocumentPageDashboardChart.getGeneralFilterFromState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleShowListFilter = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showListFilter: true, //this.state.activeViewTypeId !== DocumentPageViewTypeId.Reports,
            listFilterFilter: filter
        });
    };

    handleListFilterPanelOk = (closeDialog: boolean, newFilterState: IDocumentPageFilterState): any => {
        const newState = {
            ...this.state,
            ...newFilterState
        };
        this.setState({
            showListFilter: !closeDialog,
            ...newFilterState,
            //dataId: this.state.dataId + 1,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return DocumentPageDashboardChart.getGeneralFilterFromState(newState);
    };
    
    handleFilterPanelCancel = () => {
        this.setState({ showListFilter: false });
    };
    // #endregion Record Filter

    // #region Units
    handleRefreshPageData = async (companyId: string) => {
        const pageData = await documentService.getDocumentPageData(companyId);
        if (!pageData) return;
        const state = this.state;
        //Keywords
        const keywords = pageData.keywords ?? [];
        const selectedKeywordIds = Base.keepAvailableSelectedIds(keywords, state.selectedKeywordIds);
        const stateChange = {
            activeCompanyId: companyId,
            dataId: state.dataId + 1,
            keywords,
            selectedKeywordIds,
            canEditProperties: pageData.canEditProperties,
            settingsActions: this.getSettingsActions(pageData.canEditProperties)
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };
    // #endregion Units

    handleShowDetailsPanel = (showDocumentPreview) => {
        this.setState({ showDocumentPreview });
        AppUtils.callService(() => userService.saveUserParameter(userParameterCodeShowDocumentPreview, showDocumentPreview ? "TRUE" : "FALSE"), false, true);
    };

    handleShowPublishedVersionOnDocumentPreview = (showPublishedVersionOnDocumentPreview) => {
        this.setState({ showPublishedVersionOnDocumentPreview });
    };

    handleChangeEditMode = (editMode: boolean) => {
        this.setState({ editMode });
    };

    // #region Settings
    handleShowSettingsDialog = () => {
        this.setState({
            showSettingsDialog: true
        });
    };
    
    handleSettingsDialogOk = async () => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        await this.handleRefreshPageData(this.state.activeCompanyId);
    };
    // #endregion Settings

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.documentPage ? props.documentPage.companies : [];
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.Documents}
                    companies={sessionState.isSuperAdmin ? companies : []}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar>
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    <DocumentFolders
                        sessionState={sessionState}
                        canEditProperties={state.canEditProperties}
                        companies={companies}
                        companyId={state.initialized ? state.activeCompanyId : ""}
                        dataId={state.dataId.toString(10)}
                        listFilterIsSet={state.listFilterIsSet}
                        selectedKeywordIds={state.selectedKeywordIds}
                        selectedKeywordOperatorId={state.selectedKeywordOperatorId}
                        selectedDocumentApprovalId={state.selectedDocumentApprovalId}
                        selectedDocumentContentSearchId={state.selectedDocumentContentSearchId}
                        selectedMaxResultsCount={state.selectedMaxResultsCount}
                        selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                        selectedStartDate={state.selectedStartDate}
                        selectedEndDate={state.selectedEndDate}
                        selectedDynamicDocumentEndDateFilterId={state.selectedDynamicDocumentEndDateFilterId}
                        selectedDocumentEndDateStartDate={state.selectedDocumentEndDateStartDate}
                        selectedDocumentEndDateEndDate={state.selectedDocumentEndDateEndDate}
                        showDocumentPreview={state.showDocumentPreview}
                        showPublishedVersionOnDocumentPreview={state.showPublishedVersionOnDocumentPreview}
                        editMode={state.editMode}
                        settingsVisible={state.settingsActions?.length > 0}
                        onShowSettingsDialog={this.handleShowSettingsDialog}
                        onChangeShowDocumentPreview={this.handleShowDetailsPanel}
                        onChangeShowPublishedVersionOnDocumentPreview={this.handleShowPublishedVersionOnDocumentPreview}
                        onChangeEditMode={this.handleChangeEditMode}
                        onOpenFiltersPanel={this.handleShowListFilter}
                        onChangeActiveCompany={this.handleChangeActiveCompanyId}
                    />
                </PageContent>
                <DocumentFilterDrawer
                    open={state.showListFilter}
                    filter={state.listFilterFilter}
                    keywords={state.keywords}
                    dynamicTimeFilters={state.dynamicTimeFilters}
                    documentEndDateDynamicTimeFilters={state.documentEndDateDynamicTimeFilters}
                    selectedKeywordIds={state.selectedKeywordIds}
                    selectedKeywordOperatorId={state.selectedKeywordOperatorId}
                    selectedDocumentApprovalId={state.selectedDocumentApprovalId}
                    selectedDocumentContentSearchId={state.selectedDocumentContentSearchId}
                    selectedMaxResultsCount={state.selectedMaxResultsCount}
                    selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                    selectedStartDate={state.selectedStartDate}
                    selectedEndDate={state.selectedEndDate}
                    selectedDynamicDocumentEndDateFilterId={state.selectedDynamicDocumentEndDateFilterId}
                    selectedDocumentEndDateStartDate={state.selectedDocumentEndDateStartDate}
                    selectedDocumentEndDateEndDate={state.selectedDocumentEndDateEndDate}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.handleListFilterPanelOk}
                    onCancel={this.handleFilterPanelCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Document}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <DocumentSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        settingsActions={state.settingsActions}
                        onClose={this.handleSettingsDialogOk}
                    />
                }
            </PageContainer>
        );
    }
}